import Color from "color-js";
import {
	colors,
	headingTypes,
	buttonSizes,
	boxShadows,
	borderRadiuses,
} from "./declares";

// convert all colors to hex format

const preparedColors = Object.fromEntries(
	Object.entries(colors).map(([key, value]) => [key, Color(value).toString()])
);

const preparedColorsDefaults = Object.fromEntries(
	Object.entries(colors).map(([key, value]) => [key, Color(value).toString()])
);

// // create mixins of box shadows
const boxShadowPrepared = {
	minimal: boxShadows.minimal.join(", "),
	panel: boxShadows.panel.join(", "),
	buttonWithText: boxShadows.buttonWithText.join(", "),
};

const borderRadiusPrepared = {
	minimal: `${borderRadiuses.minimal}rem`,
	panel: `${borderRadiuses.panel}rem`,
	element: `${borderRadiuses.element}rem`,
	card: `${borderRadiuses.card}rem`,
	table: `${borderRadiuses.table}rem`,
	messages: `${borderRadiuses.messages}rem`,
	landing: `${borderRadiuses.landing}rem`,
	progressBarLanding: `${borderRadiuses.progressBarLanding}rem`,
	progressBar: `${borderRadiuses.progressBar}rem`,
};

function createBoxShadow(levels) {
	const shadows = levels.map((name) =>
		!boxShadows[name] ? [name] : boxShadows[name]
	);
	return [].concat(...shadows).join(", ");
}

const utils = {
	createBoxShadow,
};

const theme = {
	utils,
	colors: preparedColors,
	colorsDefaults: preparedColorsDefaults,
	headings: headingTypes,
	buttons: buttonSizes,
	boxShadows: boxShadowPrepared,
	borderRadius: borderRadiusPrepared,
	isDarkMode: false,
};

export default theme;
